import { FunctionComponent, useEffect, useState } from 'react';
import Link from 'next/link';

import { Routes } from '../../../constants/Routes';

import { getImageURLByIdFromProxy } from '../../../services/content/image/Image';
import { ListModel } from '../../../services/content/list/models/ListModel';
import { AuthorModel } from '../../../services/content/author/models/AuthorModel';
import { overrideImageAutoCrop } from '../../../services/content/image/ImageConfiguration';
import { ImageModel, ImageRatios, ImageSizes } from '../../../services/content/image/models/ImageModel';

import S365Picture, { preLoadImage } from '../../Image/S365Picture';

import styles from '../../../styles/DayFly24FestDays.module.scss';

const sponsorsList = [
    { imgSrc: '/dayFly24FestDays/sofia_mel.png', href: 'https://sofiamel.bg/bg/' },
    { imgSrc: '/dayFly24FestDays/billa.png', href: 'https://www.billa.bg/' },
    { imgSrc: '/dayFly24FestDays/ferratum.png', href: 'https://www.ferratum.bg/' },
    {
        imgSrc: '/dayFly24FestDays/liebherr.png',
        href: 'https://www.liebherr.com/bg-bg/хладилници-фризери/bytovaya-tehnika-2559288',
    },
];

type Props = {
    list: ListModel | null | undefined;
    authors: AuthorModel[];
};

export const DayFly24FestDays: FunctionComponent<Props> = ({ list, authors }) => {
    const categorySlug = list?.configuration?.category?.seo?.slug;
    const logoId = (list?.configuration?.category?.mainMedia?.[0] as ImageModel)?.id;
    const [logo, setLogo] = useState<string | null>(null);

    useEffect(() => {
        (async () => {
            if (logoId) {
                const imageUrl = await getImageURLByIdFromProxy(logoId)
                    .then((image) => image)
                    .catch(() => {
                        return null;
                    });

                await preLoadImage(imageUrl)
                    .then(() => {
                        setLogo(imageUrl);
                    })
                    .catch();
            }
        })();
    }, [logoId]);

    if (authors.length === 0) {
        return null;
    }

    return (
        <div className={`${styles.wrapper} container`}>
            {categorySlug && (
                <Link href={Routes.openCategory(categorySlug)} className={`${styles.logoLink}`}>
                    {logo && <S365Picture url={logo + '?'} className={`${styles.logo}`} />}
                </Link>
            )}
            <div className={`${styles.authorList}`}>
                {authors.map((author) => {
                    const imageUrl =
                        author.avatarUrl &&
                        overrideImageAutoCrop(author.avatarUrl, ImageRatios.RATIO_4X3, ImageSizes.MID);

                    return (
                        <Link
                            key={author.id}
                            href={Routes.openAuthor(author.id)}
                            className={`${styles.authorListItem}`}>
                            <S365Picture url={imageUrl} isPriority={true} />
                            <p>{author.seo.description}</p>
                        </Link>
                    );
                })}
            </div>
            <div className={`${styles.footer}`}>
                <h4>Със съдействието на:</h4>
                <div className={`${styles.sponsorList}`}>
                    {sponsorsList.map((sponsor) => (
                        <a key={sponsor.imgSrc} href={sponsor.href} target='_blank'>
                            <img src={sponsor.imgSrc} />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};
